module.exports = __webpack_public_path__ + "img/session2_card_icon3.ade9daed.png";